















































































import { Component, Vue } from "vue-property-decorator";
import API from "../store/api";

@Component({
  components: {}
})
export default class ForgotPasswordView extends Vue {
  username: string = "";
  enterUsername: boolean = false;
  sent: boolean = false;
  delivered: boolean = false;
  error: boolean = false;

  acknowledgeSent(): void {
    this.sent = false;
  }

  acknowledgeError(): void {
    this.error = false;
  }

  acknowledgeEnterUsername(): void {
    this.enterUsername = false;
  }

  redirectToLogin(): void {
    this.$router.push({ name: "login" });
  }

  async sendPasswordResetRequest(): Promise<void> {
    if (this.username == "") {
      this.enterUsername = true;
    } else {
      // let the user know that their request is being processed
      this.sent = true;

      const responseOK: boolean = await API.forgotPasswordRequest(this.username);

      // let the user know what happened
      this.delivered = responseOK;
      this.error = !responseOK;
      this.sent = false;
    }
  }
}
